<template>
  <div class="page-container flex-column">
    <HomeLocation />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import HomeLocation from '@/components/HomeLocation.vue'

export default defineComponent({
  components: {
    HomeLocation,
  },
})
</script>
